import React from "react";

import { Helmet } from "react-helmet";

interface Props {
	businessName: string;
	subTitle: string;
}

const PageTitle = ({ businessName, subTitle }: Props) => {
	return (
		<Helmet>
			<title>{`${businessName} | ${subTitle}`}</title>
		</Helmet>
	);
};

export default React.memo(PageTitle);
